export default __webpack_public_path__ + "static/media/1687.57b051d3.png";